// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Grid: React.FC<{ width?: number; height?: number }> = ({ width = 16, height = 14 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 14">
            <path
                fill="currentColor"
                d="M8.75 1.5v4.75h5.75V2c0-.275-.225-.5-.5-.5zm-1.5 0H2c-.275 0-.5.225-.5.5v4.25h5.75zM1.5 7.75V12c0 .275.225.5.5.5h5.25V7.75zm7.25 4.75H14c.275 0 .5-.225.5-.5V7.75H8.75zM0 2C0 .897.897 0 2 0h12c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2z"
            />
        </svg>
    );
};

export default React.memo(Grid);
